module.exports = __webpack_public_path__ + "static/img/2_3_4.9e92b595.jpg";